import React from 'react';
import { Form, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { Input } from 'components';
import BeneficiariesComissionsList from '../BeneficiariesComissionsList';

import convertFractionToPercent from 'utils/math/convertFractionToPercent';
import useValidation from 'hooks/forms/useValidation';

import { MIN_POOL_COMMISSION } from 'constants/commission';

import { ICommissionFormGroupProps } from './CommissionFormGroup.types';
import calcTotalCommission from './utils/calcTotalCommission';

const { Text } = Typography;

const CommissionFormGroup = ({ value, title, fieldsPrefix, loading }: ICommissionFormGroupProps) => {
  const { t } = useTranslation();
  const rules = useValidation();

  const totalComission = calcTotalCommission(value);

  return (
    <>
      <div className="np-new-scheme-form__subtitle">
        <Text>{t(title)}</Text>
      </div>

      <Form.Item
        validateFirst
        label={t('form.label.pool')}
        name={[fieldsPrefix, 'poolCommission']}
        rules={[rules.required, rules.fractionalNumber, rules.requiredMinNum(MIN_POOL_COMMISSION)]}
      >
        <Input disabled={loading} />
      </Form.Item>

      <BeneficiariesComissionsList
        name={[fieldsPrefix, 'beneficiaries']}
        value={value?.beneficiaries}
        disabled={loading}
      />

      <Space>
        <Text>{t('form.label.totalComission')}:</Text>
        <Text strong>{convertFractionToPercent(totalComission, { fixed: 2 })}</Text>
      </Space>
    </>
  );
};

export default CommissionFormGroup;
